// import React from 'react';
// import Header from '../components/Frontend/Header';
// import Footer from '../components/Frontend/Footer';
// import CoursesWeOffer from '../components/Frontend/coursesWeOffer';
// import FameWall from '../components/Frontend/FameWall';
// import Testimonial from '../components/Frontend/Testimonial';
// import VideoTuts from '../components/Frontend/VideoTuts';
// import WhyLove from '../components/Frontend/WhyLove';
// import { Link} from 'react-router-dom';
// import { Helmet } from "react-helmet";
// import ReactGA from 'react-ga';
// import API,{base} from "api.js";
// import Unauthorized from 'components/Exceptions/Unauthorized';

// class Home extends React.Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//           data: [],
//           arr:{1 : [1,2,3,4,5],2 :[6,7],3 :[8,9,10,11,12],4: [13,14,15,16,17,18,19,20]},
//           group:[],
//           mock:{},
//           result:false,
//           remarks:[],
//           activeTab:1,
//           user:false,
//           f:true,
//           unauthorized: false
//         };
//       }
//     componentDidMount() {
//         API({
//             method: 'GET',
//             url: 'mock/resultDetail/'+this.props.match.params.id
//           }).then(data => {
//             if(
//               typeof data.data.message !== 'undefined' && 
//               typeof data.data.message !== undefined && 
//               data.data.message === 'unauthorized access'
//             ) {
//               this.setState({unauthorized: true});
//             }
//             let group = data.data.data.question.reduce((r, a) => {
//                r[a.type] = [...r[a.type] || [], a];
//                return r;
//               }, {});
//             this.setState({group:group,result:data.data.data,data:data.data.data.question,mock:data.data.data.mock,remarks:data.data.remarks,user:data.data.user});
//         }).catch(()=>{
          
//         });
//     }

//   getQuestionType = (type) =>{
//     let title = "";
//     switch(type) {
//       case 1:
//         title = "Read Aloud";
//         break;
//       case 2:
//         title = "Repeat Sentence"
//         break;
//       case 3:
//         title = "Describe Image";
//         break;
//       case 4:
//         title = "Re-tell Lecture";
//         break;
//       case 5:
//         title = "Answer Short Questions";
//         break;
//       case 6:
//         title = "Summarize written text";
        
//         break;
//       case 7:
//         title = "Write Essay";
        
//         break;
//       case 8:
//         title = "Multiple Type, Single Answer ";
//         break;
//       case 9:
//         title = "Multiple Type, Double Answer ";
//         break;
//       case 10:
//         title = "Reorder Paragraph ";
//         break;
//       case 11:
//         title = "Reading Fill in the Blanks ";
//         break;
//       case 12:
//         title = "Fill in the Blanks Reading & Writing ";
//         break;
//       case 13:
//         title = "Summarize Spoken text ";
//         break;
//       case 14:
//         title = "MCQ Single answer ";
//         break;
//       case 15:
//         title = "MCQ multiple answer ";
//         break;
//       case 16:
//         title = "Listening Fill In the Blanks ";
//         break;
//       case 17:
//         title = "Highlight correct summary ";
//         break;
//       case 18:
//         title = "Select Missing Word ";
//         break;
//       case 19:
//         title = "Highlight Incorrect word ";
//         break;
//       case 20:
//         title = "Write from Dictation ";
        
//         break;
//       default:
//         // code block
//     }
//     return title;
//   }

//   getMockType = (type) =>{
//     let title = "";
//     switch(type) {
//       case 1:
//         title = "Speaking Mock Test";
//         break;
//       case 2:
//         title = "Writing Mock Test"
//         break;
//       case 3:
//         title = "Reading Mock Test";
//         break;
//       case 4:
//         title = "Listening Mock Test";
//         break;
//       case 5:
//         title = "Full Mock Test";
//         break;
//     }
//     return title;
//   }

//   calculateScore = (arr) => {
//     let score = 0;
//     let from = 0;
//     arr.map((v)=>{
//         v.score.map((val)=>{
//           score += val.score;
//           from += val.from;
//         });
//     });
//     let per = score*100/from;
//     return per.toFixed(2);
//   }
//   calculateRemarks = (arr) => {
//     let content_sc = 0;
//     let content_fr = 0;
//     let overall_sc = 0;
//     let overall_fr = 0;
//     let pro_sc = 0;
//     let pro_fr = 0;
//     let score = 0;
//     let fluency_sc = 0;
//     let fluency_fr = 0;
//     let grammar_sc = 0;
//     let grammar_fr = 0;
//     let vocab_sc = 0;
//     let vocab_fr = 0;
//     let form_sc = 0;
//     let form_fr = 0;
//     let spelling_sc = 0;
//     let spelling_fr = 0;
//     let struct_sc = 0;
//     let struct_fr = 0;
//     let ling_sc = 0;
//     let ling_fr = 0;
//     let from = 0;
//     let type = ""; 
//     arr.map((v)=>{
//         type = v.type;
//         v.score.map((val)=>{
//           if (val.type ===1) {
//             fluency_sc += val.score;
//             fluency_fr += val.from;
//           }
//           if (val.type ===0) {
//             content_sc += val.score;
//             content_fr += val.from;
//           }
//           if (val.type ===2) {
//             pro_sc += val.score;
//             pro_fr += val.from;
//           }
//           if (val.type ===3) {
//             overall_sc += val.score;
//             overall_fr += val.from;
//           }if (val.type ===4) {
//             grammar_sc += val.score;
//             grammar_fr += val.from;
//           }if (val.type ===5) {
//             form_sc += val.score;
//             form_fr += val.from;
//           }if (val.type ===6) {
//             vocab_sc += val.score;
//             vocab_fr += val.from;
//           }if (val.type ===7) {
//             spelling_sc += val.score;
//             spelling_fr += val.from;
//           }if (val.type ===8) {
//             struct_sc += val.score;
//             struct_fr += val.from;
//           }if (val.type ===9) {
//             ling_sc += val.score;
//             ling_fr += val.from;
//           }
//           score += val.score;
//           from += val.from;
//         });
//     });
//     let newArr = [(content_sc*100)/content_fr, (fluency_sc*100)/fluency_fr,(pro_sc*100)/pro_fr,(overall_sc*100)/overall_fr, (grammar_sc*100)/grammar_fr,(form_sc*100)/form_fr,(vocab_sc*100)/vocab_fr ,(spelling_sc*100)/spelling_fr, (struct_sc*100)/struct_fr, (ling_sc*100)/ling_fr ]
//     //console.error(newArr)
//     let remarkAr ="";
//     newArr.map((v,k)=>{
//       if (!isNaN(v)) {
//         let mapArr = this.getScoreType(v,type,k);
//         if (![8,9].includes(parseInt(k))) {
//           remarkAr += ' '+(mapArr.length >0 )?'<strong>'+this.remarks(k,type)+' </strong>'+mapArr[0].remarks+' <br/>':"";  
//         }
        
//       }
      
//     });
//     return remarkAr;
//   }

//   getScoreType =(per,type,scType)=>{
//     return this.state.remarks.filter((a)=>{
//       return (a.min <= per) && (a.max >= per) && a.type == type && a.score_type == scType;
//     });
//   }

//     remarks = (type,qType) => {
//       let str="";
//       if (qType === 5) {
//         return "";
//       }
//       switch(type) {
//         case 0:
//           str ="Content : ";
//           break;
//         case 1:
//           str ="Fluency : ";
//           break;
//         case 2:
//           str ="Pronunciation : ";
//           break;
//         case 3:
//           str ="";
//           break;
//         case 4:
//           str ="Grammar :";
//           break;
//         case 5:
//           str ="Form : ";
//           break;
//         case 6:
//           str ="Vocabulary : ";
//           break;
//         case 7:
//           str ="Spelling : ";
//           break;
//         case 8:
//           str ="Linguistic range : ";
//           break;
//         case 9:
//           str ="Structure : ";
//           break;
//         default:
//           str = "";
//       }
//       return str;
      
//     }

//   getTime = (arr) => {
//     let time = 0;
//     arr.map((v)=>{
//         time += v.q_time;
//     });
//     return (time > 59)?`${Math.floor(time/60)} minutes ${Math.floor(time%60)} sec`:`${time} sec`;
//   }

//   getUnattempted = (arr) => {
//     let c = 0;
//     arr.map((v)=>{
//       if (v.not_attempted == 0) {
//           c += 1;
//       }
        
//     });
//     return c;
//   }
//  render(){   

//   console.log("inside feedback");
  
//     return (
//     <React.Fragment>
    

//     <Helmet htmlAttributes>
//         <title>Top PTE Training Institute In Parramatta | Best NAATI CCL Coaching Centre In Sydney</title>
//         <meta name="twitter:title" content="Top PTE Training Institute In Parramatta | Best NAATI CCL Coaching Centre In Sydney" />
//         <meta property="og:title" content="Top PTE Training Institute In Parramatta | Best NAATI CCL Coaching Centre In Sydney" />
//         <meta name="description" content="Language Academy, being the top NAATI / PTE training institute in Parramatta, work with an aim of providing quality education to students at affordable prices and help them achieve their dream of permanent residency in Australia. To join the best PTE and NAATI coaching classes, contact us at info@languageacademy.com.au" />      
        
//         <meta name="twitter:description" content="Language Academy, being the top NAATI / PTE training institute in Parramatta, work with an aim of providing quality education to students at affordable prices and help them achieve their dream of permanent residency in Australia. To join the best PTE and NAATI coaching classes, contact us at info@languageacademy.com.au" />
//         <meta property="og:description" content="Language Academy, being the top NAATI / PTE training institute in Parramatta, work with an aim of providing quality education to students at affordable prices and help them achieve their dream of permanent residency in Australia. To join the best PTE and NAATI coaching classes, contact us at info@languageacademy.com.au" />      
//       </Helmet>
//       <Header />
//       <div className="innerPage">
//         <section className="bannerOuter">
//       <div className="container">
//         <div className="row">
//           <div className="col-sm-12 text-center">
//             <h1>Mock Test Feedback</h1>
//             {this.state.result && <span>
//               <b>{this.state?.mock?.title}</b><br/>
//               <b>Mock Type: </b>{this.getMockType(this.state?.mock?.category)}<br/>
//               <b>Submitted at: </b>{this.state.result?.aus_date} (AEDT)
//             </span>}
//           </div>
//         </div>
//       </div>
//     </section>
//     </div>
//     <div className="innerPage">
//     <br/>
//     { !this.state.unauthorized ? ( <>
//     <section className="mockTestFeedback">
//         <div className="container">
//             <div className="row">                
//                 <div className="col-sm-12 feedbackCntnt">
//                     <div className="feedUserImg">
//                         {this.state.user && <img src={(this.state.user.image)?base+this.state.user.image:"data:image/jpeg;base64,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"} alt="support" />}
//                     </div>
//                     <h3 className="userName">{this.state.user && this.state.user.first_name+' '+this.state.user.last_name}</h3>
//                     {Object.keys(this.state.group).map((val, key) => {
//                         if (![8,9,15,14,18,17].includes(parseInt(val))) {
//                           return (
//                             <div className="remarksBreakdown">
//                                 <h5>{this.getQuestionType(parseInt(val))}</h5>
//                                 <p><b>Question Attempted</b> - {this.state.group[val].length}</p>
//                                 <p><b>Score Percentage</b> - {this.calculateScore(this.state.group[val])} %</p>
//                                 <p><b>Remarks</b> - <p dangerouslySetInnerHTML={{__html: this.calculateRemarks(this.state.group[val])}}></p></p>                       
//                             </div>
//                         );  
//                         }                        
//                       })}
                    
//                 </div>
//             </div>
//         </div>  
//     </section>
//     </>) : <Unauthorized /> }
//     <Footer />
//     </div>
//     </React.Fragment>);
//     }
// }

// export default Home;


import React, { useState, useEffect } from 'react';
// import Header from '../components/Frontend/Header';
import FeedbackNavbar from '../components/Frontend/FeedbackNavbar';
import Spinner from 'components/Loader/Spinner';
import Footer from '../components/Frontend/Footer';
import CoursesWeOffer from '../components/Frontend/coursesWeOffer';
import FameWall from '../components/Frontend/FameWall';
import Testimonial from '../components/Frontend/Testimonial';
import VideoTuts from '../components/Frontend/VideoTuts';
import WhyLove from '../components/Frontend/WhyLove';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import API, { base } from "api.js";
import Unauthorized from 'components/Exceptions/Unauthorized';
import "../views/Score.css";

const Home = (props) => {
  const params = useParams();
  
  const [state, setState] = useState({
    data: [],
    arr: { 1: [1, 2, 3, 4, 5, 21, 22], 2: [6, 7], 3: [8, 9, 10, 11, 12], 4: [13, 14, 15, 16, 17, 18, 19, 20] },
    group: [],
    mock: {},
    result: false,
    remarks: [],
    activeTab: 1,
    user: false,
    f: true,
    unauthorized: false
  });

  useEffect(() => {
    API({
      method: 'GET',
      url: 'mock/resultDetail/' + params.id
    }).then(data => {
      if (
        typeof data.data.message !== 'undefined' &&
        typeof data.data.message !== undefined &&
        data.data.message === 'unauthorized access'
      ) {
        setState(prevState => ({ ...prevState, unauthorized: true }));
      }
      let group = data.data.data.question.reduce((r, a) => {
        r[a.type] = [...r[a.type] || [], a];
        return r;
      }, {});
      setState(prevState => ({
        ...prevState,
        group: group,
        result: data.data.data,
        data: data.data.data.question,
        mock: data.data.data.mock,
        remarks: data.data.remarks,
        user: data.data.user
      }));
    }).catch(() => {

    });
  }, [params.id]);

  const getQuestionType = (type) => {
    let title = "";
    switch (type) {
      case 1:
        title = "Read Aloud";
        break;
      case 2:
        title = "Repeat Sentence"
        break;
      case 3:
        title = "Describe Image";
        break;
      case 4:
        title = "Re-tell Lecture";
        break;
      case 5:
        title = "Answer Short Questions";
        break;
      case 6:
        title = "Summarize Written Text";

        break;
      case 7:
        title = "Write Essay";

        break;
      case 8:
        title = "Multiple Choice, Single Answers ";
        break;
      case 9:
        title = "Multiple Choice, Multiple Answers";
        break;
      case 10:
        title = "Reorder Paragraph ";
        break;
      case 11:
        title = "Fill In The Blanks (Drop-down) ";
        break;
      case 12:
        title = "Fill In The Blanks (Drag & Drop)";
        break;
      case 13:
        title = "Summarize Spoken Text ";
        break;
      case 14:
        title = "Multiple Choice, Single Answers";
        break;
      case 15:
        title = "Multiple Choice, Multiple Answers";
        break;
      case 16:
        title = "Fill In the Blanks (Type In)";
        break;
      case 17:
        title = "Highlight Correct Summary ";
        break;
      case 18:
        title = "Select Missing Words";
        break;
      case 19:
        title = "Highlight Incorrect Words";
        break;
      case 20:
        title = "Write from Dictation ";
        break;
      case 21:
        title = "Respond To Situation";
        break;
      case 22:
        title = "Summarize Group Discussion";
        break;
      default:
      // code block
    }
    return title;
  }

  const getMockType = (type) => {
    let title = "";
    switch (type) {
      case 1:
        title = "Speaking Mock Test";
        break;
      case 2:
        title = "Writing Mock Test"
        break;
      case 3:
        title = "Reading Mock Test";
        break;
      case 4:
        title = "Listening Mock Test";
        break;
      case 5:
        title = "Full Mock Test";
        break;
    }
    return title;
  }

  const calculateScore = (arr) => {
    let score = 0;
    let from = 0;
    arr.map((v) => {
      v.score.map((val) => {
        score += val.score;
        from += val.from;
      });
    });
    let per = score * 100 / from;
    return per.toFixed(2);
  }

  const calculateRemarks = (arr) => {
    console.log("arr", arr);
    let remarkAr = "";
    
    // For question types that don't use the scoring system (8, 9, 14, 15, 17, 18)
    // Just return the remarks directly from the score array
    if ([8, 9, 14, 15, 17, 18].includes(arr[0]?.type)) {
      const uniqueRemarks = new Set();
      arr.map((v) => {
        v.score.map((val) => {
          if (val.remarks && !uniqueRemarks.has(val.remarks)) {
            uniqueRemarks.add(val.remarks);
            const label = remarks(val.type, v.type);
            remarkAr += (label ? '<strong>' + label + '</strong>' : '') + val.remarks + '<br/>';
          }
        });
      });
      return remarkAr;
    }
    
    // For other question types, use the existing logic
    let content_sc = 0, content_fr = 0;
    let overall_sc = 0, overall_fr = 0;
    let pro_sc = 0, pro_fr = 0;
    let fluency_sc = 0, fluency_fr = 0;
    let grammar_sc = 0, grammar_fr = 0;
    let vocab_sc = 0, vocab_fr = 0;
    let form_sc = 0, form_fr = 0;
    let spelling_sc = 0, spelling_fr = 0;
    let struct_sc = 0, struct_fr = 0;
    let ling_sc = 0, ling_fr = 0;
    let type = "";
    
    arr.map((v) => {
      type = v.type;
      v.score.map((val) => {
        if (val.type === 0) { content_sc += val.score; content_fr += val.from; }
        if (val.type === 1) { fluency_sc += val.score; fluency_fr += val.from; }
        if (val.type === 2) { pro_sc += val.score; pro_fr += val.from; }
        if (val.type === 3) { overall_sc += val.score; overall_fr += val.from; }
        if (val.type === 4) { grammar_sc += val.score; grammar_fr += val.from; }
        if (val.type === 5) { form_sc += val.score; form_fr += val.from; }
        if (val.type === 6) { vocab_sc += val.score; vocab_fr += val.from; }
        if (val.type === 7) { spelling_sc += val.score; spelling_fr += val.from; }
        if (val.type === 8) { struct_sc += val.score; struct_fr += val.from; }
        if (val.type === 9) { ling_sc += val.score; ling_fr += val.from; }
      });
    });
    
    let newArr = [
      (content_sc * 100) / content_fr,
      (fluency_sc * 100) / fluency_fr,
      (pro_sc * 100) / pro_fr,
      (overall_sc * 100) / overall_fr,
      (grammar_sc * 100) / grammar_fr,
      (form_sc * 100) / form_fr,
      (vocab_sc * 100) / vocab_fr,
      (spelling_sc * 100) / spelling_fr,
      (struct_sc * 100) / struct_fr,
      (ling_sc * 100) / ling_fr
    ];
    
    newArr.map((v, k) => {
      if (!isNaN(v)) {
        let mapArr = getScoreType(v, type, k);
        if (![8, 9].includes(k) && mapArr.length > 0) {
          const label = remarks(k, type);
          remarkAr += (label ? '<strong>' + label + '</strong>' : '') + mapArr[0].remarks + '<br/>';
        }
      }
    });
    
    return remarkAr;
  }

  const getScoreType = (per, type, scType) => {
    return state.remarks.filter((a) => {
      return (a.min <= per) && (a.max >= per) && a.type == type && a.score_type == scType;
    });
  }

  const remarks = (type, qType) => {
    let str = "";
    if (qType === 5) {
      return "";
    }
    switch (type) {
      case 0:
        str = "Content : ";
        break;
      case 1:
        str = "Fluency : ";
        break;
      case 2:
        str = "Pronunciation : ";
        break;
      case 3:
        str = "";
        break;
      case 4:
        str = "Grammar :";
        break;
      case 5:
        str = "Form : ";
        break;
      case 6:
        str = "Vocabulary : ";
        break;
      case 7:
        str = "Spelling : ";
        break;
      case 8:
        str = "Linguistic range : ";
        break;
      case 9:
        str = "Structure : ";
        break;
      default:
        str = "";
    }
    return str;

  }

  const getTime = (arr) => {
    let time = 0;
    arr.map((v) => {
      time += v.q_time;
    });
    return (time > 59) ? `${Math.floor(time / 60)} minutes ${Math.floor(time % 60)} sec` : `${time} sec`;
  }

  const getUnattempted = (arr) => {
    let c = 0;
    arr.map((v) => {
      if (v.not_attempted == 0) {
        c += 1;
      }

    });
    return c;
  }

  return (
    <React.Fragment>


      <Helmet htmlAttributes>
        <title>Top PTE Training Institute In Parramatta | Best NAATI CCL Coaching Centre In Sydney</title>
        <meta name="twitter:title" content="Top PTE Training Institute In Parramatta | Best NAATI CCL Coaching Centre In Sydney" />
        <meta property="og:title" content="Top PTE Training Institute In Parramatta | Best NAATI CCL Coaching Centre In Sydney" />
        <meta name="description" content="Language Academy, being the top NAATI / PTE training institute in Parramatta, work with an aim of providing quality education to students at affordable prices and help them achieve their dream of permanent residency in Australia. To join the best PTE and NAATI coaching classes, contact us at info@languageacademy.com.au" />

        <meta name="twitter:description" content="Language Academy, being the top NAATI / PTE training institute in Parramatta, work with an aim of providing quality education to students at affordable prices and help them achieve their dream of permanent residency in Australia. To join the best PTE and NAATI coaching classes, contact us at info@languageacademy.com.au" />
        <meta property="og:description" content="Language Academy, being the top NAATI / PTE training institute in Parramatta, work with an aim of providing quality education to students at affordable prices and help them achieve their dream of permanent residency in Australia. To join the best PTE and NAATI coaching classes, contact us at info@languageacademy.com.au" />
      </Helmet>
      {/* <Header /> */}
      <FeedbackNavbar/>
      {state.data.length === 0 ? <Spinner /> : <>
      <div className="innerPage">
        <section className="bannerOuter">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 text-center">
                <h1>Mock Test Feedback</h1>
                {state.result && <span>
                  <b>{state?.mock?.title}</b><br />
                  <b>Mock Type: </b>{getMockType(state?.mock?.category)}<br />
                  <b>Submitted at: </b>{state.result?.aus_date} (AEDT)
                </span>}
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="innerPage">
        <br />
        {!state.unauthorized ? (<>
          <section className="mockTestFeedback">
            <div className="container">
             <div className="row d-flex justify-content-center">
                <div style={{width:"80%"}} className="col-sm-12 feedbackCntnt">
                  <div className="text-center mb-5">
                    <div className="feedUserImg">
                      {state.user && <img src={(state.user.image) ? base + state.user.image : "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAMAAACahl6sAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAG2YAABzjgAA+swAAIT6AAB5gQAA/RMAADBtAAASKQ0eJk4AAAMAUExURevr7Jydn5manJucnuPj5JiZm9vb3PT09MvLzMLCw5GSlPr6+qeoqdXV1tHR0rW1trW2uKusrbi4urO0tLq6vKiqq7e4uLW2tqGipLm6ury8vr6+vr+/wLu8vM7OztDQ0cjJytjY2dTU1aipqqqrrMXGxqanqKmqq6Wmp9LT062usKSlprS0ta2trra2t6ytrqWmqK2ur66vsK6ur7CwsbOztK+vsK+wsbKys7GxsqOkpqOkpZ6foampq6qqrJ2eoKenqaysraKjpZqbnbi4uaKjpKSlp5eYmqioqqurrKChory8vKGio6amqKCho7Gys7CxsrGysrKzs5+gop+gobS1tbq6u7e3uLCxsbKztLi4uJWWmJaXmba3t7i5ub29vZWXmZSWmLq6upOVl5SVl7m5up6foLq7u7u7vJqcnZOUlpeZm5aYmpKUlry8vZKTlpGTlZCRlJCRk6ytr9bX197e3q+vsb2+v8DAweDh4bOztebm5ujp6e/v756eoP///4CAgIGBgYKCgoODg4SEhIWFhYaGhoeHh4iIiImJiYqKiouLi4yMjI2NjY6Ojo+Pj5CQkJGRkZKSkpOTk5SUlJWVlZaWlpeXl5iYmJmZmZqampubm5ycnJ2dnZ6enp+fn6CgoKGhoaKioqOjo6SkpKWlpaampqenp6ioqKmpqaqqqqurq6ysrK2tra6urq+vr7CwsLGxsbKysrOzs7S0tLW1tba2tre3t7i4uLm5ubq6uru7u7y8vL29vb6+vr+/v8DAwMHBwcLCwsPDw8TExMXFxcbGxsfHx8jIyMnJycrKysvLy8zMzM3Nzc7Ozs/Pz9DQ0NHR0dLS0tPT09TU1NXV1dbW1tfX19jY2NnZ2dra2tvb29zc3N3d3d7e3t/f3+Dg4OHh4eLi4uPj4+Tk5OXl5ebm5ufn5+jo6Onp6erq6uvr6+zs7O3t7e7u7u/v7/Dw8PHx8fLy8vPz8/T09PX19fb29vf39/j4+Pn5+fr6+vv7+/z8/P39/f7+/v///zfARREAAAeqSURBVHja7N3xVxJZFMBxQAQVilzPSTslBxcDdwdtBQRBDQUFBYNMDTcoNLAMM7QD23JozvvX94cJZBhQZ+bdO2/26F/Q59wv8K48JwP5n/wY7iH3kHvIPYT6D89bLBazfiF8Y+T09PT09MOHzc3Nd+8yeoTwb99+/PjkSbfj8eN83qYPSCOTOTs7O3veEP69UkcegEIdMpPJCI6zz5/f9p9HPp9//97KMsTwLZO5o2Nh4RmrkHrpmxzHwsICzyLEWSq1IXd1TE6aWYNYSqVSqSRzHpOTDsdDliC2ksBQ4HA4zOxA6iURRJ7DccizAbE9fVpyNXhlXTkcjsNDHxMQKyGEWBV35Tg89Pl8rKTVUtHVoc/n89mYgPBK3686Dt8EIcQwMzOjKUTF+1XHMbG0tLT095s3y8vL77WCqHq/Ehy+Lsdybm9aC4irRKGrLkcut7cXiUTQIS1588jfPo/cXiQSibxGhtTpdyU4kCElyq/zXMdx9AwT0qI+j1zbEQwiQmyUX+fXXR0Fg0EXGsQK1dXRUTAYDIbRIJBdBYNhNIgFsqtgOBx2IkFguwqHQyEcSAu2q3AICwLcVSjEh1oYEPCuQgbix4A4obsK+QmPAwHtKhTy+3+gvEacsF2F/H5/wIAIAevK7/cHAhgQgPNuzzwCgcAiFgSoK3/bgQWhuUdJuwosYkGgu1pcnDdgQCju5wPmMY8CAeyqPY/5+To8BKErPAjY50fb8QIHAnIu6Z7HCxwI0Lmk24ECge8KB4LQ1YuNDYS3X4SuNjbGESAIXW2M40DAuxofH0c4ayF0hQNB6AoJAt8VDgShq/GdHQwIYFfteezMIkCgzrsiBwZkhPp+LulqFgXyB/X9XDoPFEgTviscCE99P+/+/PjlwIAQ6vu5dB4vX2JAALvaaTu8OBCoc0m7q5deHAjYuaQzD68fAwJ3Luk4vC4MyAh4V17vAwxIE7orr9fLY0AIdFde7xpBg8B09cuBCAHtyrvmxoLAdrXm/h0DUgfvas3tdvPQEBdCV2632+3eHgWFwL9ftR12+yYg5CfIfi7pyu3ettvtdkAI2B4lnYfdbndBQiD28wGO9XUwiAFmP5e8zu0CxGOFgrgQu1pf93hcUJA84HlX/DoXIDkoCNB+3r8rj8fjgYIA7ef9u4KGoHXl8XheAUKAzyXdXXlezcFBwM8lXV29moODoHY1BwfB7QoSgtoVIARuj+rXFTAEtCvxPJKPoCBm1K6SyZ9gx3jorrodc0kObh/B7CrJzQJCELviZA1EJsQAtp9LuwKFENA9SjwPbhoSYgbbzwVGl0PeQGT/gg5sP+/tipuFhRCkruQORD5kFPa8qzAsJb/Ehj3v/uqKM8NDSANmPxd11cD5fgS8K5Q/3yOE2L7l9vYWALpKPuI4jsP7M3DhB+JcovyBbmoeJ0K/K45oASG0u0py09pAND7v0oM0qe7nSU4zCKG7R2kJofw5yGsFcVLcz1UOROXztah2pSWE6vkqatUO0qS2n3McFyXaQYiP2h6l0qH6qYCU9nMuGmUBon6P4qLRh9pCrJS6UjsQ9Q+cXKKwR3HRaPQfrSGESlfRFaI5pK7284OKg8aDiyl0tcIEpKV4j6LooPIoaYParlZ4NiBE2X5+7fiXMAIh6rpaIcxAeDVdUXHQem78A/n7ecfRYAlCphXsURTnQfG/JJC/RwkO9iCy9yjBEWcNoqyrlTiTEPldxZmEKOgqHt9iDyL782MlHo9vsQeRtZ9fO5iDyNyjOg72IIq62tqaYg0ib4+6drAJkd3VFJMQBV1NTe2yC5HTFZOQO+9R3fPYZQ4iu6spwcEq5PY9StTV7m6WLYjtVFlXu9nsCDMQi9+ruKtsNptOp9N/WTWHmJ/I2s8l88im0+n0/v7+Qc6mHcSiZI8a4Dg4OFhdVXGnRjHks9I9StpVx7G6uvrpU8yJCHmudD+/cR6CIxaLxR5gQJT/3ufOjljMaDQ6ASHN18q+P5fRVcdhNBqNQ9tWAEhL+ffnCuZhNBqNQ0NDQ0N+qpCmyu85lTu+fEkkEnYLDcio6u/PFXbVcSQSiYTJ5FQFeU7le0518xAcJpPJNKMMUqL0/Tk1h2l4eHh4RB6kPkHlHvKA827HsS/bMXx+nvqtdUcItfvt9OcxfH6eSqVSqa8/boU06d2/AnR8LRaLN0Pq9O6339aVckfqa7FYLB7fBKF0DxlhHsXj42PjQEgIqqspCEehUBgA8dG5347S1fFxoVAo2PpCWrrqqlAoFE5OWn0gBr11VTg5Oan0gdC63w45j1Svo2KVQujdQ8bq6qRSqVQkkAlq95DxuqpUKmUJhNb9dsyuKpVyeVQC0WNX5XK52gOx6LKrcrlabYghE5Tut+N2VS5Xq3YxhNo9ZNyuqtXqhQhipXS/HburavVCDKkzvUcN7qp60QPZ1GtXFxc1EYTV/fwaMmgetV4Iu/v5jV3VarW6CML2fj64q1qt9mc3hPX9fPA8ape9ED3sUX3mcXl5KYboY4/q5xgTQdjfz/t31QvRb1djYz0QvXYlhbC/n/ftqgeinz1KMo8eiG72KKlDBNHPHtXbVT+ILrsaG7vqgei0q6ur770QfXZ19V2A/DcAHpmC7NcZ4/wAAAAASUVORK5CYII="} alt="support" />}
                    </div>
                    <h3 className="userName mb-4">
  {state.user && [state.user.first_name, state.user.last_name].filter(Boolean).join(' ')}
</h3>
                  </div>

                  <div className="feedback-cards-container">
                    {Object.keys(state.group).map((val, key) => {
                      // if (![8, 9, 15, 14, 18, 17].includes(parseInt(val))) {
                        return (
                          <div className="feedback-card" key={key}>
                            <div className="feedback-header">
                              <h5>{getQuestionType(parseInt(val))}</h5>
                            </div>
                            <div className="feedback-card-body">
                              <div className="feedback-info-row">
                                <div>
                                  <div className="feedback-label">Questions Attempted</div>
                                  <div className="feedback-value">{state.group[val].length}</div>
                                </div>
                                <div>
                                  <div className="feedback-label">Score Percentage</div>
                                  <div className="feedback-value">{calculateScore(state.group[val])} %</div>
                                </div>
                              </div>
                              <div className="feedback-label">Detailed Feedback</div>
                              <div className="remarks-content mt-2" dangerouslySetInnerHTML={{ __html: calculateRemarks(state.group[val]) }}></div>
                            </div>
                          </div>
                        );
                      }
                    // }
                    )}
                  </div>

                </div>
              </div>
            </div>
          </section>
        </>) : <Unauthorized />}
        <Footer />
      </div>
      </>}
    </React.Fragment>
  );
}

export default Home;